<template>
  <div class="ppt-board">
    <!-- 加载中（与 HomeView 一致） -->
    <div class="board-loading" v-if="loading">
      <div style="display: flex; flex-direction: column; align-items: center">
        <img
          style="height: 75px; transform: scale(2)"
          src="../../assets/img/cocoloading.gif"
          alt=""
        />
        <div style="color: #0354d7">{{ lang.Loadingdes }}</div>
      </div>
    </div>
    <!-- 顶部导航栏（毛玻璃效果） -->
    <div class="topbar">
      <div class="topbar-inner">
        <div class="brand">
          <div class="brand-logo"><i class="ri-bar-chart-2-fill"></i></div>
          <div class="brand-text">
            <div class="t1">Teacher Analytics</div>
            <div class="t2">{{ lang.dbBoardSubtitle }}</div>
          </div>
        </div>
        <div class="topbar-right">
          <div class="segmented">
            <button :class="{ active: range === 'month' }" @click="range = 'month'">{{ lang.dbThisMonth }}</button>
            <button :class="{ active: range === 'term' }" @click="range = 'term'">{{ lang.dbThisTerm }}</button>
            <!-- <button :class="{ active: range === 'custom' }" @click="range = 'custom'">
              <i class="ri-calendar-line"></i> 自定义
            </button> -->
          </div>
          <button class="export-btn" type="button" :disabled="exporting" @click="handleExport">
            <i class="ri-download-2-line"></i>
            <span>{{ exporting ? lang.dbExporting : lang.dbExportPdf }}</span>
          </button>
          <button class="export-btn" type="button" :disabled="exporting" @click="handleExportExcel">
            <i class="ri-file-excel-2-line"></i>
            <span>{{ exporting ? lang.dbExporting : lang.dbExportExcel }}</span>
          </button>
          <div class="avatar-chip">
            <div class="av">{{ (displayName || '?').charAt(0) }}</div>
            <span class="name">{{ displayName }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="page">
      <div class="page-head">
        <h1>{{ lang.dbPageTitle }}</h1>
        <p>{{ pageDesc }}</p>
      </div>

      <!-- ===================== 教师发展建议（置顶） ===================== -->
      <div class="module" ref="modSuggest" v-if="false">
        <div class="module-head">
          <div class="module-badge" style="color:var(--accent-orange);"><i class="ri-lightbulb-flash-line"></i></div>
          <div class="module-title-wrap">
            <h2>{{ lang.dbSuggTitle }}</h2>
            <p>{{ lang.dbSuggSub }}</p>
          </div>
        </div>

        <div class="suggestion-layout">
          <!-- 左侧：教学洞察摘要 -->
          <div class="insight-summary">
            <i class="ri-double-quotes-l quote-icon"></i>
            <div class="title">{{ lang.dbInsightTitle }}</div>
            <div class="text" v-html="lang.dbInsightText"></div>
          </div>

          <!-- 右侧：3条建议 -->
          <div class="suggestion-cards-wrap">
            <div class="sugg-card c-blue">
              <div class="sugg-card-body">
                <div class="sugg-icon"><i class="ri-shuffle-line"></i></div>
                <div class="sugg-text">{{ lang.dbSuggText1 }}</div>
              </div>
              <div class="sugg-actions-col">
                <div class="sugg-source" @click="scrollTo('mod2')">
                  <i class="ri-eye-line"></i> {{ lang.dbViewEvidence }}
                </div>
                <button class="sugg-btn primary-hover" :title="lang.dbRegenTitle"><i class="ri-refresh-line"></i> {{ lang.dbRegenerate }}</button>
              </div>
            </div>

            <div class="sugg-card c-orange">
              <div class="sugg-card-body">
                <div class="sugg-icon"><i class="ri-user-heart-line"></i></div>
                <div class="sugg-text">{{ lang.dbSuggText2 }}</div>
              </div>
              <div class="sugg-actions-col">
                <div class="sugg-source" @click="scrollTo('mod3')">
                  <i class="ri-eye-line"></i> {{ lang.dbViewEvidence }}
                </div>
                <button class="sugg-btn primary-hover" :title="lang.dbRegenTitle"><i class="ri-refresh-line"></i> {{ lang.dbRegenerate }}</button>
              </div>
            </div>

            <div class="sugg-card c-purple">
              <div class="sugg-card-body">
                <div class="sugg-icon"><i class="ri-robot-2-line"></i></div>
                <div class="sugg-text">{{ lang.dbSuggText3 }}</div>
              </div>
              <div class="sugg-actions-col">
                <div class="sugg-source" @click="scrollTo('mod4')">
                  <i class="ri-eye-line"></i> {{ lang.dbViewEvidence }}
                </div>
                <button class="sugg-btn primary-hover" :title="lang.dbRegenTitle"><i class="ri-refresh-line"></i> {{ lang.dbRegenerate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ===================== 模块一：教学应用概览 ===================== -->
      <div class="module" ref="mod1">
        <div class="module-head">
          <div class="module-badge"><i class="ri-dashboard-3-line"></i></div>
          <div class="module-title-wrap">
            <h2>{{ lang.dbMod1Title }}</h2>
            <p>{{ lang.dbMod1Sub }}</p>
          </div>
        </div>

        <div class="grid g-4" style="margin-bottom:24px;">
          <div class="card kpi-card">
            <div class="kpi-top">
              <div class="kpi-icon"><i class="ri-building-4-line"></i></div>
              <!-- <div class="kpi-trend up"><i class="ri-arrow-up-line"></i>持平</div> -->
            </div>
            <div class="kpi-value">{{ classCount }}</div>
            <div class="kpi-label">{{ lang.dbKpiClassCount }}</div>
            <div class="kpi-spark" ref="spark1"></div>
          </div>
          <div class="card kpi-card">
            <div class="kpi-top">
              <div class="kpi-icon" style="color:var(--accent-green); background:var(--accent-green-soft);"><i class="ri-presentation-line"></i></div>
              <!-- <div class="kpi-trend up" style="color:var(--accent-green); background:var(--accent-green-soft);"><i class="ri-arrow-up-line"></i>12%</div> -->
            </div>
            <div class="kpi-value">{{ info.courseCount }}</div>
            <div class="kpi-label">{{ lang.dbKpiCourseCount }}</div>
            <div class="kpi-spark" ref="spark2"></div>
          </div>
          <div class="card kpi-card">
            <div class="kpi-top">
              <div class="kpi-icon" style="color:var(--accent-purple); background:var(--accent-purple-soft);"><i class="ri-group-line"></i></div>
              <!-- <div class="kpi-trend up" style="color:var(--accent-purple); background:var(--accent-purple-soft);"><i class="ri-arrow-up-line"></i>5%</div> -->
            </div>
            <div class="kpi-value">{{ info.studentCount }}</div>
            <div class="kpi-label">{{ lang.dbKpiStudentCount }}</div>
            <div class="kpi-spark" ref="spark3"></div>
          </div>
          <div class="card kpi-card">
            <div class="kpi-top">
              <div class="kpi-icon" style="color:var(--accent-orange); background:var(--accent-orange-soft);"><i class="ri-time-line"></i></div>
              <!-- <div class="kpi-trend up" style="color:var(--accent-orange); background:var(--accent-orange-soft);"><i class="ri-arrow-up-line"></i>15%</div> -->
            </div>
            <div class="kpi-value">{{ info.usage }}</div>
            <div class="kpi-label">{{ lang.dbKpiUsage }}</div>
            <div class="kpi-spark" ref="spark4"></div>
          </div>
        </div>

        <div class="card chart-card" style="margin-bottom:24px;">
          <div class="chart-head">
            <div>
              <div class="chart-title">{{ lang.dbTrendTitle }} <span class="tag-pill tag-blue">{{ lang.dbTagCombo }}</span></div>
              <div class="chart-sub">{{ lang.dbTrendSub }}</div>
            </div>
          </div>
          <div ref="chart1Combo" style="height:360px;"></div>
        </div>

        <div class="grid g-65-35">
          <div class="card chart-card">
            <div class="chart-head">
              <div>
                <div class="chart-title">{{ lang.dbScatterTitle }} <span class="tag-pill tag-blue">{{ lang.dbTagScatter }}</span></div>
                <div class="chart-sub">{{ lang.dbScatterSub }}</div>
              </div>
            </div>
            <div ref="chart1Scatter" style="height:320px;"></div>
          </div>

          <div class="card chart-card" style="display:flex; flex-direction:column;">
            <div class="chart-head" style="margin-bottom:16px;">
              <div>
                <div class="chart-title">{{ lang.dbCourseRankTitle }}</div>
                <div class="chart-sub">{{ lang.dbCourseRankSub }}</div>
              </div>
            </div>
            <div class="student-list-container">
              <div class="rank-item" v-for="item in courseRank" :key="item.rank">
                <div class="info">
                  <div class="rank-num" :class="'top-' + item.rank">{{ item.rank }}</div>
                  <div>
                    <div class="name">{{ item.name }}</div>
                    <div class="metric">{{ item.metric }}</div>
                  </div>
                </div>
                <div class="rank-score">{{ item.score }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ===================== 模块二：课程创建与设计分析 ===================== -->
      <div class="module" ref="mod2">
        <div class="module-head">
          <div class="module-badge"><i class="ri-palette-line"></i></div>
          <div class="module-title-wrap">
            <h2>{{ lang.dbMod2Title }}</h2>
            <p>{{ lang.dbMod2Sub }}</p>
          </div>
        </div>

        <div class="grid g-4" style="margin-bottom:24px;">
          <div class="card kpi-card" style="padding:20px 24px;">
            <div class="kpi-label" style="margin-bottom:8px;">{{ lang.dbAiBeikeCount }}</div>
            <div class="kpi-value" style="font-size:28px;">{{ aiBeiKe }} <span style="font-size:14px; color:var(--text-light); font-weight:600;">{{ lang.dbUnitTimes }}</span></div>
          </div>
          <div class="card kpi-card" style="padding:20px 24px;">
            <div class="kpi-label" style="margin-bottom:8px;">{{ lang.dbAiBeikeRate }}</div>
            <div class="kpi-value" style="font-size:28px; color:var(--accent-green);">{{ Number((aiBeiKe / beikeArray.length * 100).toFixed(2)) }} <span style="font-size:14px; font-weight:600;">%</span></div>
          </div>
          <div class="card kpi-card" style="padding:20px 24px;">
            <div class="kpi-label" style="margin-bottom:8px;">{{ lang.dbSmartAppRate }}</div>
            <div class="kpi-value" style="font-size:28px; color:var(--accent-purple);">{{ smartApp }} <span style="font-size:14px; font-weight:600;">%</span></div>
          </div>
          <div class="card kpi-card" style="padding:20px 24px;">
            <div class="kpi-label" style="margin-bottom:8px;">{{ lang.dbAiAssistantRate }}</div>
            <div class="kpi-value" style="font-size:28px; color:var(--accent-orange);">{{ aiAssistant }} <span style="font-size:14px; font-weight:600;">%</span></div>
          </div>
        </div>

        <div class="grid g-2-3-2" style="margin-bottom:24px;">
          <div class="card chart-card">
            <div class="chart-head">
              <div>
                <div class="chart-title">{{ lang.dbBeikeTrendTitle }} <span class="tag-pill tag-blue">{{ lang.dbTagDualLine }}</span></div>
                <div class="chart-sub">{{ lang.dbBeikeTrendSub }}</div>
              </div>
            </div>
            <div ref="chart2Area" style="height:300px;"></div>
          </div>

          <div class="card chart-card">
            <div class="chart-head">
              <div>
                <div class="chart-title">{{ lang.dbToolPrefTitle }} <span class="tag-pill tag-gray">{{ lang.dbTagPie }}</span></div>
                <div class="chart-sub">{{ lang.dbToolPrefSub }}</div>
              </div>
            </div>
            <div ref="chart2Pie" style="height:300px;"></div>
          </div>
        </div>
      </div>

      <!-- ===================== 模块三：学生学习参与分析 ===================== -->
      <div class="module" ref="mod3">
        <div class="module-head">
          <div class="module-badge"><i class="ri-team-line"></i></div>
          <div class="module-title-wrap">
            <h2>{{ lang.dbMod3Title }}</h2>
            <p>{{ lang.dbMod3Sub }}</p>
          </div>
        </div>

        <div class="grid g-65-35" style="margin-bottom:32px;">
          <div class="card chart-card">
            <div class="chart-head">
              <div>
                <div class="chart-title">{{ lang.dbClassPartTitle }} <span class="tag-pill tag-blue">{{ lang.dbTagDualCompare }}</span></div>
                <div class="chart-sub">{{ lang.dbClassPartSub }}</div>
              </div>
            </div>
            <div ref="chart3Line" style="height:320px;"></div>
          </div>

          <div class="card chart-card" style="display:flex; flex-direction:column;">
            <div class="chart-head" style="margin-bottom:16px;">
              <div>
                <div class="chart-title">{{ lang.dbClassRankTitle }}</div>
                <div class="chart-sub">{{ lang.dbClassRankSub }}</div>
              </div>
            </div>
            <div class="student-list-container">
              <div class="rank-item" v-for="item in classRank" :key="item.rank">
                <div class="info">
                  <div class="rank-num" :class="'top-' + item.rank">{{ item.rank }}</div>
                  <div>
                    <div class="name">{{ item.name }}</div>
                    <div class="metric">{{ item.metric }}</div>
                  </div>
                </div>
                <div class="rank-score">{{ item.score }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 学生个体参与情况 -->
        <div class="stu-section-head">
          <div>
            <h3>{{ lang.dbStuSectionTitle }}</h3>
            <div class="stu-section-sub">{{ lang.dbStuSectionSub }}</div>
          </div>
          <select v-model="selectedClass" class="class-select">
            <option v-for="opt in classOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
          </select>
        </div>

        <div class="grid g-65-35">
          <div class="grid g-2">
            <div class="card kpi-card">
              <div class="kpi-icon" style="margin-bottom:16px; background:var(--accent-green-soft); color:var(--accent-green);"><i class="ri-chat-poll-line"></i></div>
              <div class="kpi-value">{{ stuAvgInter }}</div>
              <div class="kpi-label">{{ lang.dbAvgInter }}</div>
            </div>
            <div class="card kpi-card" style="display:flex;align-items:center;justify-content:space-between;">
              <div>
                <div class="kpi-icon" style="margin-bottom:16px;"><i class="ri-upload-2-line"></i></div>
                <div class="kpi-value">{{ stuSubmitCount }}</div>
                <div class="kpi-label">{{ lang.dbSubmitCount }}</div>
              </div>
              <div class="gauge-mini" ref="gaugeMini"></div>
            </div>
            <div class="card kpi-card">
              <div class="kpi-icon" style="margin-bottom:16px; background:var(--accent-orange-soft); color:var(--accent-orange);"><i class="ri-star-smile-line"></i></div>
              <div class="kpi-value">{{ stuQualityCount }}</div>
              <div class="kpi-label">{{ lang.dbQualityCount }}</div>
            </div>
            <div class="card kpi-card">
              <div style="display:flex;justify-content:space-between;">
                <div class="kpi-icon" style="margin-bottom:16px; background:var(--brand-primary); color:#fff;"><i class="ri-pulse-line"></i></div>
                <div class="info-icon"><i class="ri-information-line"></i>
                  <div class="popover" v-html="lang.dbCalcTip"></div>
                </div>
              </div>
              <div class="kpi-value">{{ stuOverallScore }} {{ lang.dbScoreUnit }}</div>
              <div class="kpi-label">{{ lang.dbStuOverall }}</div>
            </div>
          </div>

          <div class="card chart-card" style="display:flex; flex-direction:column;">
            <div class="chart-head" style="margin-bottom:16px; align-items:center;">
              <div>
                <div class="chart-title">{{ lang.dbStuRankTitle }}</div>
              </div>
              <div class="stu-tabs">
                <button
                  v-for="tab in stuTabs"
                  :key="tab.value"
                  class="stu-tab"
                  :class="{ active: stuTab === tab.value }"
                  @click="stuTab = tab.value"
                >{{ tab.label }}</button>
              </div>
            </div>
            <div class="student-list-container">
              <div v-show="stuTab === 'high'">
                <div class="rank-item" v-for="item in stuHigh" :key="item.rank">
                  <div class="info">
                    <div class="rank-num" :class="'top-' + item.rank">{{ item.rank }}</div>
                    <div>
                      <div class="name">{{ item.name }}</div>
                      <div class="metric">{{ item.metric }}</div>
                    </div>
                  </div>
                  <div class="rank-score">{{ item.score }}</div>
                </div>
              </div>
              <div v-show="stuTab === 'low'">
                <div class="rank-item" v-for="item in stuLow" :key="item.rank">
                  <div class="info">
                    <div class="rank-num is-muted">{{ item.rank }}</div>
                    <div>
                      <div class="name">{{ item.name }}</div>
                      <div class="metric">{{ item.metric }}</div>
                    </div>
                  </div>
                  <div class="rank-score" :class="item.scoreClass">{{ item.score }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ===================== 模块四：AI辅助教学分析 ===================== -->
      <div class="module" ref="mod4">
        <div class="module-head">
          <div class="module-badge"><i class="ri-robot-2-line"></i></div>
          <div class="module-title-wrap">
            <h2>{{ lang.dbMod4Title }}</h2>
            <p>{{ lang.dbMod4Sub }}</p>
          </div>
        </div>

        <div class="grid">
           <!-- g-2-2-3 -->
          <div class="card chart-card" v-show="false">
            <div class="chart-head">
              <div>
                <div class="chart-title">{{ lang.dbAiOverviewTitle }} <span class="tag-pill tag-gray">{{ lang.dbTagPercentPie }}</span></div>
                <div class="chart-sub">{{ lang.dbAiOverviewSub }}</div>
              </div>
            </div>
            <div ref="chart4Pie" style="height:280px; margin-top:10px;"></div>
          </div>
          <div class="card chart-card">
            <div class="chart-head">
              <div>
                <div class="chart-title">{{ lang.dbStuAiTitle }} <span class="tag-pill tag-blue">{{ lang.dbTagUsageRate }}</span></div>
                <div class="chart-sub">{{ lang.dbStuAiSub }}</div>
              </div>
            </div>
            <div ref="chart4Group" style="height:300px;"></div>
          </div>
        </div>
      </div>

      <!-- <div class="footer-note">数据更新于 2026-08-04 · 润泽课堂教学智能分析系统提供技术支持</div> -->
    </div>
  </div>
</template>


<script>
import * as echarts from 'echarts';
import 'remixicon/fonts/remixicon.css';
import { myMixin } from "@/mixins/mixin.js"
import { getPPTDataBoard_all, getUser } from "@/api/user";
import "@/common/aws-sdk-2.235.1.min.js";

const getFile = (url) => {
  return new Promise((resolve) => {
    var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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",
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域
      let url2 = url;
      let _url2 = "";
      try {
        if (
          url2.indexOf("https://view.officeapps.live.com/op/view.aspx?src=") != -1
        ) {
          _url2 = url2.split(
            "https://view.officeapps.live.com/op/view.aspx?src="
          )[1];
        } else {
          _url2 = url2;
        }
      } catch(err){
        console.log(err, url2);
        resolve({ data: 1 });
        return;
      }
      var s3 = new window.AWS.S3({ params: { Bucket: "ccrb" } });
      let name = decodeURIComponent(_url2.split("https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/")[1])
      var params = {
        Bucket: "ccrb",
        Key: name
      };
      s3.getObject(params, function (err, data) {
        if (err) {
          console.log(err)
          resolve({ data: 1 });
        }else {
          resolve({ data: data.Body });
          console.log(data);
        }        
      });
  });
};
// 企业蓝主题色盘及活泼辅助色（降低饱和度）
const COLORS = {
  primary: '#164FD7',
  primaryLight: '#3B82F6',
  green: '#10B981',
  orange: '#F97316',
  purple: '#8B5CF6',
  yellow: '#FBBF24',
  gray: '#94A3B8',
  textMain: '#1E293B',
  textMuted: '#64748B'
};

export default {
  name: 'PPTDataBoard',
  mixins: [myMixin],
  data() {
    return {
      boardUser: {}, // 本页用户信息（不走 vuex；避免与 mixin 的 roleUser 重名）
      range: 'term',
      boardRaw: null, // getPPTDataBoard_all 原始返回
      courseTimeArray: [], // payload[0] 授课记录 {time(秒), date}，用于月度趋势
      courseArray: [], // payload[1] 课程记录
      classArray: [], // payload[2] 班级记录
      scatterData: [], // 课程授课分布散点数据 [授课次数, 提交人数, 课程名, 工具数, 平均提交数]
      courseCount: 0, // 课程数（接口接入后更新）
      classCount: 0, // 班级数（接口接入后更新）
      aiBeiKe: 0, // AI辅助教学数（接口接入后更新）
      beikeArray: [], // payload[8] 备课记录 {time(秒), date, courseId}
      toolPrefData: [], // 互动工具使用偏好 [{name, value}]，仅聚合有备课记录的课程
      classNamesData: [], // 班级名列表（图表用）
      teachingCountsData: [], // 各班级授课次数（图表用）
      submitRatesData: [], // 各班级提交率 %（图表用）
      studentArray: [], // payload[4] 学生列表（用于 userid -> 姓名映射）
      workArray: [], // payload[5] 作业提交记录 {courseId, userid, classid}
      interArray: [], // payload[6] 课堂互动记录 {userid, classid}
      yworkArray: [], // payload[10] 优质作品记录 {userid, classid}
      aiArray: [], // payload[7] AI助手使用记录 {courseid, userid}
      aiGroupData: { courses: [], helperCounts: [], helperRates: [], appCounts: [], appRates: [] }, // 学生AI使用情况（图表）
      stuAvgInter: 0, // 平均课堂互动次数
      stuSubmitCount: 0, // 提交作业次数
      stuQualityCount: 0, // 优质作品展示次数
      stuOverallScore: 0, // 学生总体参与度（均分）
      stuSubmitRateGauge: 0, // 有提交行为的学生占比 %（仪表盘）
      exporting: false, // PDF 导出中
      loading: false,
      info: {
        classCount: 0,
        courseCount: 0,
        studentCount: 0,
        usage: '0h'
      },
      selectedClass: 'all',
      stuTab: 'high',
      classOptions: [
      ],
      courseRank: [
        // { rank: 1, name: '数学·几何', metric: '工具数: 12个 | 平均提交率: 96%', score: 98 },
        // { rank: 2, name: '语文·古诗', metric: '工具数: 10个 | 平均提交率: 92%', score: 92 },
        // { rank: 3, name: '英语·语法', metric: '工具数: 8个 | 平均提交率: 88%', score: 88 },
        // { rank: 4, name: '科学·实验', metric: '工具数: 15个 | 平均提交率: 82%', score: 82 },
        // { rank: 5, name: '历史·近代史', metric: '工具数: 6个 | 平均提交率: 78%', score: 76 }
      ],
      classRank: [

      ],
      stuHigh: [

      ],
      stuLow: [

      ]
    };
  },
  computed: {
    displayName() {
      const u = this.boardUser || {};
      return u.username || u.name || '';
    },
    // 当前区间对应的起止日期与展示文案
    rangeInfo() {
      const query = (this.$route && this.$route.query) || {};
      if (this.range === 'custom' && query.start && query.end) {
        return { start: query.start, end: query.end, label: this.lang.dbRangeCustom };
      }
      const r = this.calcDateRange(this.range === 'custom' ? 'term' : this.range);
      let label = this.lang.dbTermLabel;
      if (this.range === 'month') {
        label = this.lang.dbMonthLabel;
      } else {
        const sm = parseInt(r.start.slice(5, 7), 10);
        const year = parseInt(r.start.slice(0, 4), 10);
        label = year + (sm >= 9 ? this.lang.dbAutumnTerm : this.lang.dbSpringTerm);
      }
      return { start: r.start, end: r.end, label };
    },
    rangeDesc() {
      const info = this.rangeInfo;
      return info.label + this.lang.dbParenL + info.start + this.lang.dbDateSep + info.end + this.lang.dbParenR;
    },
    // 页面头统计文案：语言包模板按顺序替换 *
    pageDesc() {
      return (this.lang.dbPageDescTpl || '')
        .replace('*', this.rangeDesc)
        .replace('*', this.courseCount)
        .replace('*', this.classCount);
    },
    // 互动工具名称映射（语言包）
    taskTools() {
      return {
        45: this.lang.dbTool45,
        15: this.lang.dbTool15,
        73: this.lang.dbTool73,
        72: this.lang.dbTool72,
        78: this.lang.dbTool78,
        79: this.lang.dbTool79,
        831: this.lang.dbTool831,
        832: this.lang.dbTool832,
        84: this.lang.dbTool84
      };
    },
    stuTabs() {
      return [
        { value: 'high', label: this.lang.dbHighTop },
        { value: 'low', label: this.lang.dbLowTop }
      ];
    },
    aiAssistant() { // AI助手使用率
      return Number((this.courseArray.filter((item) => item.isUseAiAssistant).length / this.courseArray.length * 100).toFixed(2)); // 保留2位小数
    },
    smartApp() { // 智能应用使用率
      return Number((this.courseArray.filter((item) => item.isUseAiApp).length / this.courseArray.length * 100).toFixed(2)); // 保留2位小数
    }
  },
  watch: {
    // 切换本月/本学期时重新拉取数据
    range() {
      this.fetchBoardData();
    },
    // 切换班级筛选时重算学生个体参与情况
    selectedClass() {
      this.calcStudentStats();
    }
  },
  created() {
    this.charts = {};
    this.injectedLinks = [];
  },
  async mounted() {
    this.loadExternalAssets();
    await this.ensureUserInfo();
    this.fetchBoardData();
    this.$nextTick(() => {
      this.initSparks();
      this.initCombo();
      this.initScatter();
      this.initLessonArea();
      this.initToolPie();
      this.initGauge();
      this.initClassLine();
      this.initAiPie();
      this.initAiGroup();
    });
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    Object.keys(this.charts).forEach((key) => {
      this.charts[key] && this.charts[key].dispose();
    });
    this.charts = {};
    this.injectedLinks.forEach((link) => link.parentNode && link.parentNode.removeChild(link));
  },
  methods: {
    // 本页直接请求用户信息，写入 boardUser（依赖路由 query.userid）
    async ensureUserInfo() {
      try {
        const userid = ((this.$route && this.$route.query) || {}).userid || '';
        const res = await getUser({ userid });
        this.boardUser = (((res || {}).data || [])[0] || [])[0] || {};
      } catch (e) {
        console.error('[PPTDataBoard] 获取用户信息失败：', e);
      }
    },
    // 拉取教师数据看板（getPPTDataBoard_all）
    async fetchBoardData() {
      const query = (this.$route && this.$route.query) || {};
      const userid = query.userid || (this.boardUser && this.boardUser.userid) || '';
      // start/end 与头部展示共用同一份计算逻辑（rangeInfo）
      const range = this.rangeInfo;
      const params = { userid, start: range.start, end: range.end };
      console.log('[PPTDataBoard] getPPTDataBoard_all 请求参数：', params);
      try {
        this.loading = true;
        const res = await getPPTDataBoard_all(params);
        // 兼容 axios.config 返回的 response：真实数据在 res.data
        const payload = res && res.data;
        console.log('[PPTDataBoard] getPPTDataBoard_all 响应原始：', res);
        console.log('[PPTDataBoard] getPPTDataBoard_all 数据：', payload);

        // 课程数和班级数
        this.courseCount = payload[1].length;
        this.classCount = payload[3].length;

        // 基础信息
        this.info.classCount = this.classCount; // 班级数
        this.info.courseCount = payload[0].length; // 授课次数
        this.info.studentCount = payload[4].length; // 学生数

        // 使用时长：payload[2] 中各时间值为秒，求和后换算成小时
        const totalSeconds = payload[2].reduce((sum, item) => sum + (parseInt(item.text) || 0), 0);
        this.info.usage = (totalSeconds / 3600).toFixed(1) + 'h';

        // 授课记录：提取 time(秒) 与 date，用于月度趋势
        this.courseTimeArray = payload[0].map((item) => {
          return {
            time: parseInt(item.time),
            date: item.date,
            courseId: item.courseId,
            classid: item.classid, // 授课班级ID 单个班级ID
          };
        });

        const taskTools = this.taskTools;
        let toolsNum = Object.keys(taskTools);
        // 课程数组
        this.courseArray = (await Promise.all(payload[1].map(async (item) => {
          let chapters = JSON.parse(item.chapters);
          let data
          try {
            data = await getFile(chapters.pptData)
          } catch (error) {
            // getFile 获取失败，跳过该课程
            console.warn('[PPTDataBoard] getFile 获取失败，跳过该课程：', chapters.pptData, error)
            return false
          }
          console.log('pptData:', data && data.data, chapters.pptData)
          let pptdata = data
          // pptdata.data 是 ArrayBuffer，需要先转成字符串再解析为 JSON
          let jsonStr = ''
          let pptJSON = {}
          let isUseAiApp = false;
          if (pptdata && pptdata.data && pptdata.data != 1) {
            // 先将 ArrayBuffer 转为字符串
            const uint8Array = new Uint8Array(pptdata.data)
            jsonStr = new TextDecoder('utf-8').decode(uint8Array)
            try {
              const jsonObj = JSON.parse(jsonStr)
              pptJSON = jsonObj
              // console.log(pptJSON)
            } catch (error) {
              console.error('JSON 解析错误:', error);
            }
          }else {
            // getFile 未取到有效数据，跳过该课程
            console.warn('[PPTDataBoard] pptData 无有效数据，跳过该课程：', pptdata && pptdata.data, chapters.pptData)
            return false
          }
          let pptSlides = pptJSON.slides || [];
          let tools = 0
          let tasks = []
          for (let i = 0; i < pptSlides.length; i++) {
            const hasSubmissionTool = pptSlides[i].elements.filter((element) => {
              return element.type === 'frame' && toolsNum.includes(element.toolType.toString());
            });
            if (hasSubmissionTool.length > 0) {
                let pageid = hasSubmissionTool[0].id;
                const match = hasSubmissionTool[0].url.match(/[?&]id=([^&]+)/)
                let id = match && match[1] || '';
                if (hasSubmissionTool[0].toolType == '72') {
                  isUseAiApp = true;
                }
                tasks.push(
                  {
                    id: id,
                    pageid: pageid,
                    name: taskTools[hasSubmissionTool[0].toolType],
                    type: taskTools[hasSubmissionTool[0].toolType],
                    value: hasSubmissionTool.length,
                    url: hasSubmissionTool[0].url,
                    toolType: hasSubmissionTool[0].toolType,
                    task: i,
                  }
                )
                console.log(hasSubmissionTool);
                tools++;
              }
          }
          return {
            courseId: item.courseId,
            title: item.title,
            juri: item.juri,
            workCount: item.workCount,
            studentCount: item.studentCount,
            chapters: chapters,
            pptJSON: pptJSON,
            tools: tools, // 工具数量
            tasks: tasks,
            isUseAiAssistant: chapters.aiAssistant || false,
            isUseAiApp: isUseAiApp,
          };
        }))).filter(Boolean);

        console.log(this.courseArray)
        // 班级数组
        this.classArray = payload[3].map((item) => {
          return {
            classId: item.classid,
            className: item.name,
            gradeName: item.gradeName,
            studentCount: item.studentCount
          };
        });

        // 课程授课分布 + 综合排行：基于 payload[0]（授课记录）与 courseArray
        // workCount = 已提交作业数量，studentCount = 已提交人数
        const teachCountMap = {};
        payload[0].forEach((item) => {
          const cid = item.courseId;
          if (cid) teachCountMap[cid] = (teachCountMap[cid] || 0) + 1;
        });
        const scatterData = [];
        const rankList = [];
        this.courseArray.forEach((course) => {
          const teachCount = teachCountMap[course.courseId] || 0;
          const workCount = parseInt(course.workCount) || 0; // 已提交作业数量
          const studentCount = parseInt(course.studentCount) || 0; // 已提交人数
          const tools = course.tools || 0;
          const avgWork = teachCount > 0 ? +(workCount / teachCount).toFixed(1) : 0;
          // [授课次数, 作业提交数, 课程名, 工具数, 平均提交数, 已提交人数]
          scatterData.push([teachCount, workCount, course.title, tools, avgWork, studentCount]);
          rankList.push({ name: course.title, tools, workCount, studentCount, teachCount, score: workCount + tools * 3 });
        });
        this.scatterData = scatterData;
        rankList.sort((a, b) => b.score - a.score);
        this.courseRank = rankList.slice(0, 5).map((item, idx) => ({
          rank: idx + 1,
          name: item.name,
          metric: this.lang.dbCourseRankMetricTpl.replace('*', item.tools).replace('*', item.workCount).replace('*', item.studentCount),
          score: item.score
        }));

        this.beikeArray = await Promise.all(payload[8].map(async (item) => {
            return {
              time: parseInt(item.time),
              date: item.date,
              courseId: item.courseId,
            }
        }));
        
        this.aiBeiKe = payload[9].length

        // 互动工具使用偏好：仅统计有备课记录的课程（beikeArray 的 courseId 集合），按使用次数降序
        const beikeCourseIds = new Set(
          (this.beikeArray || [])
            .map((b) => String(b.courseId || ''))
            .filter((id) => id)
        );
        const toolMap = {};
        this.courseArray.forEach((course) => {
          if (!beikeCourseIds.has(String(course.courseId || ''))) return;
          (course.tasks || []).forEach((task) => {
            const name = task.name || (this.lang.dbToolFallback + task.toolType);
            toolMap[name] = (toolMap[name] || 0) + 1;
          });
        });
        this.toolPrefData = Object.keys(toolMap)
          .map((name) => ({ name, value: toolMap[name] }))
          .sort((a, b) => b.value - a.value);

        // 作业数组
        let workArray = payload[5].map((item) => {
          return {
            courseId: item.courseid,
            userid: item.userid,
            classid: item.classid, // 学生的班级数组拼接的id字符串
            atool: item.atool,
          }
        });
        this.workArray = workArray;
        this.studentArray = payload[4] || []; // 学生列表，用于 userid -> 姓名映射

        // 班级参与情况：授课次数 + 作业提交率
        // courseTimeArray.classid 是单个班级ID，workArray.classid 是逗号拼接的ID字符串
        const teachingByClass = {};
        this.courseTimeArray.forEach((item) => {
          const cid = item.classid;
          if (cid) teachingByClass[cid] = (teachingByClass[cid] || 0) + 1;
        });
        // 按班级收集去重的提交 userid 集合
        const submitUsersByClass = {};
        workArray.forEach((item) => {
          const classIds = String(item.classid || '').split(',').filter(Boolean);
          classIds.forEach((cid) => {
            if (!submitUsersByClass[cid]) submitUsersByClass[cid] = new Set();
            if (item.userid) submitUsersByClass[cid].add(item.userid);
          });
        });
        // 以 classArray 为基准汇总
        const classList = this.classArray.map((cls) => {
          const teachCount = teachingByClass[cls.classId] || 0;
          const submitUsers = (submitUsersByClass[cls.classId] || new Set()).size;
          const studentCount = cls.studentCount || 0;
          const submitRate = studentCount > 0 ? +(submitUsers / studentCount * 100).toFixed(1) : 0;
          // 综合得分：提交率 60% + 授课次数（归一化到 100 上限）40%
          const score = +(submitRate * 0.6 + Math.min(teachCount * 4, 100) * 0.4).toFixed(1);
          return { classId: cls.classId, name: cls.className, gradeName: cls.gradeName, studentCount, teachCount, submitUsers, submitRate, score };
        });
        // 图表数据（classNames + teachingCounts + submitRates）
        this.classNamesData = classList.map((c) => c.name);
        this.teachingCountsData = classList.map((c) => c.teachCount);
        this.submitRatesData = classList.map((c) => c.submitRate);
        // 班级参与排名（按 score 降序）
        classList.sort((a, b) => b.score - a.score);
        this.classRank = classList.map((c, idx) => ({
          rank: idx + 1,
          name: c.name,
          metric: this.lang.dbClassRankMetricTpl.replace('*', c.teachCount).replace('*', c.submitRate),
          score: c.score
        }));
        // 更新下拉选项（班级筛选）
        if (this.classArray.length) {
          const rateById = {};
          classList.forEach((c) => { rateById[c.classId] = c.submitRate; });
          const base = this.classArray.map((c) => ({
            value: c.classId,
            label: c.className + ' | ' + this.lang.dbSubmitRateLabel + (rateById[c.classId] || 0) + '%'
          }));
          this.classOptions = [{ value: 'all', label: this.lang.dbAllClassesTpl.replace('*', this.classArray.length) }].concat(base);
        }

        // 互动数组
        let interArray = payload[6].map((item) => {
          return {
            userid: item.userid,
            classid: item.classid, // 学生的班级数组拼接的id字符串
          }
        });
        this.interArray = interArray;

        // 优质作品展示数组
        let yworkArray = payload[10].map((item) => {
          return {
            userid: item.userid,
            classid: item.classid, // 学生的班级数组拼接的id字符串
          }
        });
        this.yworkArray = yworkArray;

        // ai助手的使用次数
        let aiArray = payload[7].map((item) => {
          return {
            courseid: item.pid,
            userid: item.userid,
          }
        });
        this.aiArray = aiArray;

        // 学生AI使用情况：按课程聚合 AI助手（aiArray）与 智能应用（workArray 中 atool==72）
        const aiHelperMap = {}; // courseid -> {count, users:Set}
        aiArray.forEach((item) => {
          const cid = item.courseid;
          if (!cid) return;
          if (!aiHelperMap[cid]) aiHelperMap[cid] = { count: 0, users: new Set() };
          aiHelperMap[cid].count += 1;
          if (item.userid) aiHelperMap[cid].users.add(item.userid);
        });
        const aiAppMap = {}; // courseId -> {count, users:Set}
        this.workArray.forEach((item) => {
          if (String(item.atool) !== '72') return; // 72 = 应用中心（智能应用）
          const cid = item.courseId;
          if (!cid) return;
          if (!aiAppMap[cid]) aiAppMap[cid] = { count: 0, users: new Set() };
          aiAppMap[cid].count += 1;
          if (item.userid) aiAppMap[cid].users.add(item.userid);
        });
        const aiGroup = { courses: [], helperCounts: [], helperRates: [], appCounts: [], appRates: [] };
        this.courseArray.forEach((course) => {
          const stuTotal = course.studentCount || 0; // 分母，兜底防除零
          const helper = aiHelperMap[course.courseId];
          const app = aiAppMap[course.courseId];
          aiGroup.courses.push(course.title);
          aiGroup.helperCounts.push(helper ? helper.count : 0);
          aiGroup.helperRates.push(helper && stuTotal > 0 ? +(helper.users.size / stuTotal * 100).toFixed(1) : 0);
          aiGroup.appCounts.push(app ? app.count : 0);
          aiGroup.appRates.push(app && stuTotal > 0 ? +(app.users.size / stuTotal * 100).toFixed(1) : 0);
        });
        this.aiGroupData = aiGroup;

        this.$nextTick(() => { this.initCombo(); this.initScatter(); this.initLessonArea(); this.initToolPie(); this.initClassLine(); this.calcStudentStats(); this.initAiGroup(); });

        this.boardRaw = payload;
        this.loading = false;
      } catch (e) {
        console.error('[PPTDataBoard] getPPTDataBoard_all 请求失败：', e);
        this.loading = false;
      }
    },
    // 学生个体参与情况：按班级筛选聚合互动/提交/优质作品，产出 4 个 KPI 与 Top5 排名
    calcStudentStats() {
      // userid -> 姓名 映射（payload[4] 字段名未验证，防御性取值，兜底 userid）
      const userMap = {};
      (this.studentArray || []).forEach((s) => {
        const uid = s.userid || s.userId || s.id;
        const nm = s.name || s.userName || s.username || s.nickname || s.realName || s.studentName;
        if (uid) userMap[uid] = nm || uid;
      });
      // 班级筛选：学生 classid 为逗号拼接字符串，'all' 表示不限
      const inScope = (classidStr) => {
        if (this.selectedClass === 'all') return true;
        return String(classidStr || '').split(',').includes(this.selectedClass);
      };
      // 范围内学生总数（平均值的分母）
      const totalStudents = this.selectedClass === 'all'
        ? (this.classArray || []).reduce((sum, c) => sum + (c.studentCount || 0), 0)
        : (((this.classArray || []).find((c) => c.classId === this.selectedClass) || {}).studentCount || 0);
      // 三个数组按 userid 聚合
      const map = {};
      const ensure = (uid) => {
        if (!map[uid]) map[uid] = { userid: uid, inter: 0, work: 0, quality: 0 };
        return map[uid];
      };
      (this.interArray || []).forEach((item) => {
        if (item.userid && inScope(item.classid)) ensure(item.userid).inter += 1;
      });
      (this.workArray || []).forEach((item) => {
        if (item.userid && inScope(item.classid)) ensure(item.userid).work += 1;
      });
      (this.yworkArray || []).forEach((item) => {
        if (item.userid && inScope(item.classid)) ensure(item.userid).quality += 1;
      });
      const students = Object.keys(map).map((uid) => map[uid]);
      const totalInter = students.reduce((sum, x) => sum + x.inter, 0);
      const totalWork = students.reduce((sum, x) => sum + x.work, 0);
      const totalQuality = students.reduce((sum, x) => sum + x.quality, 0);
      // KPI
      this.stuAvgInter = totalStudents > 0 ? +(totalInter / totalStudents).toFixed(1) : 0;
      this.stuSubmitCount = totalWork; // 提交作业次数
      this.stuQualityCount = totalQuality;
      const submitStudents = students.filter((x) => x.work > 0).length;
      this.stuSubmitRateGauge = totalStudents > 0 ? +(submitStudents / totalStudents * 100).toFixed(0) : 0;
      // 每个学生得分：max 归一化（提交 40% + 互动 40% + 优质作品 20%），max 兜底 1 防除零
      const maxInter = Math.max(1, ...students.map((x) => x.inter));
      const maxWork = Math.max(1, ...students.map((x) => x.work));
      const maxQuality = Math.max(1, ...students.map((x) => x.quality));
      students.forEach((x) => {
        x.score = +(x.work / maxWork * 40 + x.inter / maxInter * 40 + x.quality / maxQuality * 20).toFixed(1);
        x.name = userMap[x.userid] || x.userid;
      });
      this.stuOverallScore = students.length
        ? +(students.reduce((sum, x) => sum + x.score, 0) / students.length).toFixed(0)
        : 0;
      // 排名（metric 提交率 -> 提交作业次数）
      const fmt = (x) => this.lang.dbStuMetricTpl.replace('*', x.inter).replace('*', x.work);
      const sorted = students.slice().sort((a, b) => b.score - a.score);
      this.stuHigh = sorted.slice(0, 5).map((x, i) => ({
        rank: i + 1, name: x.name, metric: fmt(x), score: Math.round(x.score)
      }));
      this.stuLow = sorted.slice().reverse().slice(0, 5).map((x, i) => ({
        rank: i + 1, name: x.name, metric: fmt(x), score: Math.round(x.score),
        scoreClass: i < 3 ? 'is-orange' : 'is-main'
      }));
      this.initGauge();
    },
    // 根据区间类型计算 start/end（YYYY-MM-DD）
    // 本月：当月1号~月底；本学期：中国中小学春季 02-24~06-30、秋季 09-01~次年01-15
    calcDateRange(type) {
      const pad = (n) => String(n).padStart(2, '0');
      const now = new Date();
      const y = now.getFullYear();
      const m = now.getMonth() + 1;
      if (type === 'month') {
        const endDay = new Date(y, m, 0).getDate();
        return { start: y + '-' + pad(m) + '-01', end: y + '-' + pad(m) + '-' + pad(endDay) };
      }
      // 本学期
      if (m >= 9) {
        return { start: y + '-09-01', end: (y + 1) + '-01-15' };
      }
      if (m === 1) {
        return { start: (y - 1) + '-09-01', end: y + '-01-15' };
      }
      if (m >= 2 && m <= 6) {
        return { start: y + '-02-24', end: y + '-06-30' };
      }
      return { start: y + '-02-24', end: y + '-06-30' };
    },
    // 月份标签：按语言包输出（cn: 1月 / en: Jan）
    monthLabel(m) {
      const names = (this.lang.dbMonthNames || '').split(',');
      const idx = parseInt(m.split('-')[1], 10) - 1;
      return names[idx] || m;
    },
    // 按区间生成月份序列 ['2026-09', ...]
    listMonths(start, end) {
      const result = [];
      if (!start || !end) return result;
      const sy = parseInt(start.split('-')[0], 10);
      const sm = parseInt(start.split('-')[1], 10);
      const ey = parseInt(end.split('-')[0], 10);
      const em = parseInt(end.split('-')[1], 10);
      let y = sy, m = sm;
      while (y < ey || (y === ey && m <= em)) {
        result.push(y + '-' + String(m).padStart(2, '0'));
        m += 1;
        if (m > 12) { m = 1; y += 1; }
      }
      return result;
    },
    // 按区间生成周序列（本月视图）：自然周（周一为起点）[{start, end, label}]
    weekList(start, end) {
      const result = [];
      if (!start || !end) return result;
      const fmt = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      const s = new Date(start + 'T00:00:00');
      const e = new Date(end + 'T00:00:00');
      if (isNaN(s.getTime()) || isNaN(e.getTime())) return result;
      const cur = new Date(s);
      // 对齐到所在周的周一（getDay() 为 0 表示周日）
      const offset = cur.getDay() === 0 ? 6 : cur.getDay() - 1;
      cur.setDate(cur.getDate() - offset);
      let idx = 1;
      while (cur <= e) {
        const wStart = new Date(cur);
        const wEnd = new Date(cur);
        wEnd.setDate(wEnd.getDate() + 6);
        const realStart = wStart < s ? s : wStart;
        const realEnd = wEnd > e ? e : wEnd;
        result.push({
          start: fmt(realStart),
          end: fmt(realEnd),
          label: (this.lang.dbWeekLabel || '第*周').replace('*', idx)
        });
        idx += 1;
        cur.setDate(cur.getDate() + 7);
      }
      return result;
    },
    // 生成统计桶：本月（weekly）按周，其余按月
    chartBuckets(range, weekly) {
      if (weekly) {
        return this.weekList(range.start, range.end).map((w) => ({ label: w.label, start: w.start, end: w.end, count: 0, seconds: 0 }));
      }
      return this.listMonths(range.start, range.end).map((m) => ({ label: this.monthLabel(m), month: m, count: 0, seconds: 0 }));
    },
    // 把带 date/time 的记录累加到统计桶
    fillBuckets(buckets, records, weekly) {
      (records || []).forEach((item) => {
        const d = (item.date || '').slice(0, 10);
        if (!d) return;
        const bucket = weekly
          ? buckets.find((b) => d >= b.start && d <= b.end)
          : buckets.find((b) => d.slice(0, 7) === b.month);
        if (!bucket) return;
        bucket.count += 1;
        bucket.seconds += (item.time || 0);
      });
      return buckets;
    },
    // 动态引入英文字体（Remixicon 已通过 npm 本地打包；字体加载失败时自动回退系统字体）
    loadExternalAssets() {
      const assets = [
        { id: 'plus-jakarta-font', rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap' }
      ];
      assets.forEach((asset) => {
        if (document.getElementById(asset.id)) return;
        const link = document.createElement('link');
        link.id = asset.id;
        link.rel = asset.rel;
        link.href = asset.href;
        document.head.appendChild(link);
        this.injectedLinks.push(link);
      });
    },
    scrollTo(refName) {
      const el = this.$refs[refName];
      if (el && el.scrollIntoView) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
    handleResize() {
      Object.keys(this.charts).forEach((key) => {
        this.charts[key] && this.charts[key].resize();
      });
    },
    createChart(key, refName) {
      if (this.charts[key]) return this.charts[key];
      this.charts[key] = echarts.init(this.$refs[refName]);
      return this.charts[key];
    },
    // KPI 卡片迷你趋势图
    initSparks() {
      const sparkData = [
        { key: 'spark1', ref: 'spark1', color: COLORS.primary, data: [12, 12, 12, 12, 12, 12] },
        { key: 'spark2', ref: 'spark2', color: COLORS.primary, data: [12, 12, 12, 12, 12, 12] },
        { key: 'spark3', ref: 'spark3', color: COLORS.primary, data: [12, 12, 12, 12, 12, 12] },
        { key: 'spark4', ref: 'spark4', color: COLORS.primary, data: [12, 12, 12, 12, 12, 12] },
        // { key: 'spark2', ref: 'spark2', color: COLORS.green, data: [22, 25, 28, 30, 33, 38] },
        // { key: 'spark3', ref: 'spark3', color: COLORS.purple, data: [1200, 1300, 1380, 1450, 1500, 1560] },
        // { key: 'spark4', ref: 'spark4', color: COLORS.orange, data: [120, 140, 150, 160, 175, 186] }
      ];
      sparkData.forEach((item) => {
        const chart = this.createChart(item.key, item.ref);
        chart.setOption({
          grid: { left: 10, right: 10, top: 5, bottom: 5 },
          xAxis: { type: 'category', show: false, boundaryGap: false },
          yAxis: { type: 'value', show: false, min: 'dataMin' },
          tooltip: { show: false },
          series: [{
            type: 'line',
            data: item.data,
            smooth: true,
            symbol: 'none',
            lineStyle: { width: 2, color: item.color },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: item.color + '33' },
                { offset: 1, color: item.color + '00' }
              ])
            }
          }]
        });
      });
    },
    // 模块1：月度教学应用趋势（授课次数 + 授课时长，时长由秒换算为小时）
    initCombo() {
      // 本月视图按周统计，其余按月统计
      const weekly = this.range === 'month';
      const buckets = this.fillBuckets(this.chartBuckets(this.rangeInfo, weekly), this.courseTimeArray, weekly);
      const axisLabels = buckets.map((b) => b.label);
      const teachData = buckets.map((b) => b.count);
      const hourData = buckets.map((b) => +(b.seconds / 3600).toFixed(1));
      const gradientPrimary = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: COLORS.primaryLight },
        { offset: 1, color: COLORS.primary }
      ]);
      const chart = this.charts['combo'] || this.createChart('combo', 'chart1Combo');
      chart.setOption({
        tooltip: { trigger: 'axis', backgroundColor: 'rgba(255,255,255,0.95)', borderColor: '#E9EDF7', textStyle: { color: COLORS.textMain } },
        legend: { top: 0, data: [this.lang.dbTeachCount, this.lang.dbTeachHours], textStyle: { color: COLORS.textMuted, fontWeight: 600 } },
        grid: { left: 40, right: 40, top: 50, bottom: 60 },
        dataZoom: [{ type: 'inside' }, { type: 'slider', height: 12, bottom: 15, borderColor: 'transparent', backgroundColor: '#F4F7FE' }],
        xAxis: { type: 'category', data: axisLabels, axisLine: { lineStyle: { color: '#E9EDF7' } }, axisLabel: { color: COLORS.textMuted, fontWeight: 600 } },
        yAxis: [
          { type: 'value', name: this.lang.dbUnitCount, nameTextStyle: { color: COLORS.gray }, splitLine: { lineStyle: { color: '#F4F7FE', type: 'dashed' } }, axisLabel: { color: COLORS.gray } },
          { type: 'value', name: this.lang.dbUnitHours, nameTextStyle: { color: COLORS.gray }, splitLine: { show: false }, axisLabel: { color: COLORS.gray } }
        ],
        series: [
          { name: this.lang.dbTeachCount, type: 'bar', data: teachData, barWidth: 18, itemStyle: { color: gradientPrimary, borderRadius: [6, 6, 0, 0] } },
          { name: this.lang.dbTeachHours, type: 'line', yAxisIndex: 1, data: hourData, smooth: true, symbolSize: 8, itemStyle: { color: COLORS.orange }, lineStyle: { width: 4, shadowColor: 'rgba(249,115,22,0.3)', shadowBlur: 8, shadowOffsetY: 4 } }
        ]
      });
    },
    // 模块1：课程授课分布（散点图）
    initScatter() {
      const scatterData = this.scatterData || [];
      this.createChart('scatter', 'chart1Scatter').setOption({
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(255,255,255,0.95)',
          borderColor: '#E9EDF7',
          textStyle: { color: COLORS.textMain },
          formatter: (params) => {
            return `<div style="font-weight:700;margin-bottom:4px;color:${COLORS.textMain};">${params.data[2]}</div>
                    <div style="color:${COLORS.textMuted};font-size:13px;">${this.lang.dbTipTeachCount}: <b style="color:${COLORS.textMain};">${params.data[0]} ${this.lang.dbUnitCi}</b></div>
                    <div style="color:${COLORS.textMuted};font-size:13px;">${this.lang.dbTipWorkCount}: <b style="color:${COLORS.textMain};">${params.data[1]} ${this.lang.dbUnitFen}</b></div>
                    <div style="color:${COLORS.textMuted};font-size:13px;">${this.lang.dbTipSubmitted}: <b style="color:${COLORS.textMain};">${params.data[5]} ${this.lang.dbUnitRen}</b></div>
                    <div style="color:${COLORS.textMuted};font-size:13px;">${this.lang.dbTipAvgSubmit}: <b style="color:${COLORS.textMain};">${params.data[4]} ${this.lang.dbUnitFen}</b></div>`;
          }
        },
        grid: { left: 50, right: 30, top: 40, bottom: 40 },
        xAxis: {
          type: 'value', name: this.lang.dbTeachCount, nameLocation: 'middle', nameGap: 25,
          nameTextStyle: { color: COLORS.gray }, splitLine: { lineStyle: { color: '#F4F7FE', type: 'dashed' } }, axisLabel: { color: COLORS.gray }
        },
        yAxis: {
          type: 'value', name: this.lang.dbWorkSubmits, nameTextStyle: { color: COLORS.gray },
          splitLine: { lineStyle: { color: '#F4F7FE', type: 'dashed' } }, axisLabel: { color: COLORS.gray }
        },
        series: [{
          type: 'scatter',
          data: scatterData,
          symbolSize: (data) => Math.max(data[3] * 1.5, 12),
          itemStyle: {
            color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [{ offset: 0, color: COLORS.primaryLight }, { offset: 1, color: COLORS.primary }]),
            opacity: 0.85,
            shadowBlur: 10, shadowColor: 'rgba(22, 79, 215, 0.25)', shadowOffsetY: 4
          }
        }]
      });
    },
    // 模块2：备课活跃度趋势（备课次数 vs 备课时长）
    initLessonArea() {
      // 本月视图按周统计，其余按月统计
      const weekly = this.range === 'month';
      const buckets = this.fillBuckets(this.chartBuckets(this.rangeInfo, weekly), this.beikeArray, weekly);
      const axisLabels = buckets.map((b) => b.label);
      const beikeCountData = buckets.map((b) => b.count);
      const beikeHourData = buckets.map((b) => +(b.seconds / 3600).toFixed(1));
      const chart = this.charts['lessonArea'] || this.createChart('lessonArea', 'chart2Area');
      chart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { top: 0, data: [this.lang.dbBeikeCount, this.lang.dbBeikeHours], textStyle: { color: COLORS.textMuted, fontWeight: 600 } },
        grid: { left: 40, right: 40, top: 50, bottom: 30 },
        xAxis: { type: 'category', data: axisLabels, boundaryGap: false, axisLine: { lineStyle: { color: '#E2E8F0' } }, axisLabel: { color: COLORS.textMuted, fontWeight: 600 } },
        yAxis: [
          { type: 'value', name: this.lang.dbUnitCount, nameTextStyle: { color: COLORS.gray }, splitLine: { lineStyle: { color: '#F8FAFC', type: 'dashed' } }, axisLabel: { color: COLORS.gray } },
          { type: 'value', name: this.lang.dbUnitHours, nameTextStyle: { color: COLORS.gray }, splitLine: { show: false }, axisLabel: { color: COLORS.gray } }
        ],
        series: [
          {
            name: this.lang.dbBeikeCount, type: 'line', yAxisIndex: 0, itemStyle: { color: COLORS.primary },
            areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(22,79,215,0.4)' }, { offset: 1, color: 'rgba(22,79,215,0)' }]) },
            smooth: true, symbol: 'none', data: beikeCountData
          },
          {
            name: this.lang.dbBeikeHours, type: 'line', yAxisIndex: 1, itemStyle: { color: COLORS.green },
            areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(16,185,129,0.4)' }, { offset: 1, color: 'rgba(16,185,129,0)' }]) },
            smooth: true, symbol: 'none', data: beikeHourData
          }
        ]
      });
    },
    // 模块2：互动工具使用偏好（环形饼图）
    initToolPie() {
      const pieData = (this.toolPrefData && this.toolPrefData.length)
        ? this.toolPrefData
        : [{ name: this.lang.dbNoData, value: 0 }];
      const chart = this.charts['toolPie'] || this.createChart('toolPie', 'chart2Pie');
      chart.setOption({
        color: [COLORS.primary, COLORS.green, COLORS.purple, COLORS.orange, COLORS.yellow, '#38BDF8', '#F43F5E'],
        tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)', backgroundColor: 'rgba(255,255,255,0.95)', borderColor: '#E9EDF7', textStyle: { color: COLORS.textMain } },
        legend: { bottom: '0', left: 'center', itemWidth: 12, itemHeight: 12, textStyle: { fontSize: 13, color: COLORS.textMuted, fontWeight: 600 } },
        series: [{
          type: 'pie',
          radius: ['45%', '70%'],
          center: ['50%', '42%'],
          avoidLabelOverlap: false,
          itemStyle: { borderRadius: 10, borderColor: '#fff', borderWidth: 3 },
          label: { show: false, position: 'center' },
          emphasis: { label: { show: true, fontSize: 18, fontWeight: 800, color: COLORS.textMain } },
          labelLine: { show: false },
          data: pieData
        }]
      });
    },
    // 模块3：迷你仪表盘
    initGauge() {
      const gradientPrimary = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: COLORS.primaryLight },
        { offset: 1, color: COLORS.primary }
      ]);
      this.createChart('gauge', 'gaugeMini');
      this.charts['gauge'].setOption({
        series: [{
          type: 'gauge', startAngle: 90, endAngle: -270, radius: '100%',
          pointer: { show: false },
          progress: { show: true, overlap: false, roundCap: true, clip: false, itemStyle: { color: gradientPrimary } },
          axisLine: { lineStyle: { width: 10, color: [[1, '#F4F7FE']] } },
          splitLine: { show: false }, axisTick: { show: false }, axisLabel: { show: false },
          detail: { valueAnimation: true, fontSize: 16, fontWeight: 800, offsetCenter: [0, 0], formatter: '{value}%', color: COLORS.primary },
          data: [{ value: this.stuSubmitRateGauge || 0 }]
        }]
      });
    },
    // 模块3：班级参与情况（柱线双轴）
    initClassLine() {
      const classNames = this.classNamesData || [];
      const teachingCounts = this.teachingCountsData || [];
      const participationRate = this.submitRatesData || [];
      const gradientPrimary = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: COLORS.primaryLight },
        { offset: 1, color: COLORS.primary }
      ]);
      const chart = this.charts['classLine'] || this.createChart('classLine', 'chart3Line');
      chart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { top: 0, data: [this.lang.dbTeachCount, this.lang.dbSubmitRatePct], textStyle: { color: COLORS.textMuted, fontWeight: 600 } },
        grid: { left: 40, right: 40, top: 40, bottom: 30 },
        xAxis: { type: 'category', data: classNames, axisLine: { lineStyle: { color: '#E9EDF7' } }, axisLabel: { color: COLORS.textMuted, fontWeight: 600 } },
        yAxis: [
          { type: 'value', name: this.lang.dbUnitCount, nameTextStyle: { color: COLORS.gray }, splitLine: { lineStyle: { color: '#F4F7FE', type: 'dashed' } }, axisLabel: { color: COLORS.gray } },
          { type: 'value', name: this.lang.dbSubmitRatePct, nameTextStyle: { color: COLORS.gray }, splitLine: { show: false }, axisLabel: { color: COLORS.gray }, max: 100 }
        ],
        series: [
          { name: this.lang.dbTeachCount, type: 'bar', data: teachingCounts, barWidth: 28, yAxisIndex: 0, itemStyle: { color: gradientPrimary, borderRadius: [6, 6, 0, 0] } },
          { name: this.lang.dbSubmitRatePct, type: 'line', data: participationRate, yAxisIndex: 1, smooth: true, symbolSize: 8, itemStyle: { color: COLORS.orange }, lineStyle: { width: 3 } }
        ]
      });
    },
    // 模块4：AI应用总览（玫瑰图）
    initAiPie() {
      this.createChart('aiPie', 'chart4Pie').setOption({
        color: [COLORS.green, COLORS.purple, COLORS.primary, COLORS.orange],
        tooltip: { trigger: 'item', formatter: '{b}: {c}%', backgroundColor: 'rgba(255,255,255,0.95)', borderColor: '#E9EDF7', textStyle: { color: COLORS.textMain } },
        legend: { bottom: 0, left: 'center', itemWidth: 12, itemHeight: 12, textStyle: { fontSize: 12, color: COLORS.textMuted, fontWeight: 600 } },
        series: [{
          type: 'pie',
          radius: ['35%', '65%'],
          center: ['50%', '45%'],
          roseType: 'radius',
          itemStyle: { borderRadius: 6, borderColor: '#fff', borderWidth: 2 },
          label: { color: COLORS.textMain, fontWeight: 700, formatter: '{b}\n{c}%' },
          labelLine: { smooth: true },
          data: [
            { value: 43, name: this.lang.dbAiCat1 },
            { value: 29, name: this.lang.dbAiCat2 },
            { value: 18, name: this.lang.dbAiCat3 },
            { value: 10, name: this.lang.dbAiCat4 }
          ].sort((a, b) => a.value - b.value)
        }]
      });
    },
    // 模块4：学生AI使用情况（双Y轴：人次与使用率）
    initAiGroup() {
      const g = this.aiGroupData || { courses: [], helperCounts: [], helperRates: [], appCounts: [], appRates: [] };
      const gradientPrimary = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: COLORS.primaryLight },
        { offset: 1, color: COLORS.primary }
      ]);
      const gradientPurple = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: '#A78BFA' },
        { offset: 1, color: COLORS.purple }
      ]);
      const chart = this.charts['aiGroup'] || this.createChart('aiGroup', 'chart4Group');
      chart.setOption({
        color: [COLORS.primary, COLORS.primary, COLORS.purple, COLORS.purple],
        tooltip: { trigger: 'axis' },
        legend: { top: 0, data: [this.lang.dbAiHelperTimes, this.lang.dbAiHelperRate, this.lang.dbAiAppTimes, this.lang.dbAiAppRate], itemWidth: 12, itemHeight: 12, textStyle: { fontSize: 12, color: COLORS.textMuted, fontWeight: 600 } },
        grid: { left: 40, right: 40, top: 60, bottom: 60 },
        dataZoom: [{ type: 'inside' }, { type: 'slider', height: 12, bottom: 15, borderColor: 'transparent', backgroundColor: '#F4F7FE' }],
        xAxis: { type: 'category', data: g.courses, axisLabel: { interval: 0, color: COLORS.textMuted, fontWeight: 600 }, axisLine: { lineStyle: { color: '#E9EDF7' } } },
        yAxis: [
          { type: 'value', name: this.lang.dbPeopleTimes, nameTextStyle: { color: COLORS.gray }, splitLine: { lineStyle: { color: '#F4F7FE', type: 'dashed' } }, axisLabel: { color: COLORS.gray } },
          { type: 'value', name: this.lang.dbUsageRatePct, nameTextStyle: { color: COLORS.gray }, splitLine: { show: false }, max: 100, axisLabel: { color: COLORS.gray } }
        ],
        series: [
          { name: this.lang.dbAiHelperTimes, type: 'bar', yAxisIndex: 0, data: g.helperCounts, barWidth: 14, barGap: '20%', itemStyle: { color: gradientPrimary, borderRadius: [6, 6, 0, 0] } },
          { name: this.lang.dbAiHelperRate, type: 'line', yAxisIndex: 1, data: g.helperRates, smooth: true, symbolSize: 8, lineStyle: { width: 3 } },
          { name: this.lang.dbAiAppTimes, type: 'bar', yAxisIndex: 0, data: g.appCounts, barWidth: 14, itemStyle: { color: gradientPurple, borderRadius: [6, 6, 0, 0] } },
          { name: this.lang.dbAiAppRate, type: 'line', yAxisIndex: 1, data: g.appRates, smooth: true, symbolSize: 8, lineStyle: { type: 'dashed', width: 3 } }
        ]
      });
    },
    // 导出 PDF：截图内容区（不含顶栏），导出前临时展开所有滚动容器
    async handleExport() {
      if (this.exporting) return;
      this.exporting = true;
      const notify = (type, msg) => {
        if (this.$message && this.$message[type]) this.$message[type](msg);
        else console.log('[PPTDataBoard] ' + msg);
      };
      notify('info', this.lang.dbPdfGenerating);
      const el = this.$el.querySelector('.page') || this.$el;
      // 临时展开滚动容器：高度撑到内容全高，并逐级释放祖先节点，避免内容溢出被裁切
      const saved = [];
      const seen = new Set();
      const remember = (node) => {
        if (seen.has(node)) return;
        seen.add(node);
        saved.push({
          el: node,
          overflow: node.style.overflow,
          overflowX: node.style.overflowX,
          overflowY: node.style.overflowY,
          height: node.style.height,
          maxHeight: node.style.maxHeight
        });
        node.style.overflow = 'visible';
        node.style.overflowX = 'visible';
        node.style.overflowY = 'visible';
        node.style.maxHeight = 'none';
      };
      el.querySelectorAll('.student-list-container').forEach((e) => {
        remember(e);
        // 高度按内容实际高度固定，保证导出时容器与内容等高
        e.style.height = e.scrollHeight + 'px';
        let p = e.parentElement;
        while (p && p !== el) {
          remember(p);
          p.style.height = 'auto';
          p = p.parentElement;
        }
      });
      const restore = () => {
        saved.forEach((s) => {
          s.el.style.overflow = s.overflow;
          s.el.style.overflowX = s.overflowX;
          s.el.style.overflowY = s.overflowY;
          s.el.style.height = s.height;
          s.el.style.maxHeight = s.maxHeight;
        });
      };
      try {
        const html2canvas = require('html2canvas');
        const fn = html2canvas.default || html2canvas;
        const jspdfModule = require('jspdf');
        const jsPDF = jspdfModule.jsPDF || (jspdfModule.default && jspdfModule.default.jsPDF) || jspdfModule.default;
        await this.$nextTick();
        await new Promise((resolve) => setTimeout(resolve, 60));
        // 自适应 scale，避免整页 canvas 超过浏览器上限（约 32M 像素）
        const w = el.scrollWidth || el.offsetWidth;
        const h = el.scrollHeight || el.offsetHeight;
        const scale = Math.max(1, Math.min(2, Math.sqrt(33554432 / (w * h))));
        const canvas = await fn(el, {
          scale,
          useCORS: true,
          backgroundColor: '#F8FAFC',
          scrollX: 0,
          scrollY: 0,
          windowWidth: w,
          width: w,
          height: h,
          windowHeight: h
        });
        const imgData = canvas.toDataURL('image/png');
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const pdf = new jsPDF({
          orientation: imgWidth >= imgHeight ? 'l' : 'p',
          unit: 'px',
          format: [imgWidth / scale, imgHeight / scale]
        });
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth / scale, imgHeight / scale);
        pdf.save(this.lang.dbPdfName + '.pdf');
        notify('success', this.lang.dbExportSuccess);
      } catch (e) {
        console.error('[PPTDataBoard] 导出失败：', e);
        notify('error', this.lang.dbExportFail);
      } finally {
        restore();
        this.exporting = false;
      }
    },
    // 按模板导出 Excel（汇总数据 / 授课详情 / 备课详情）
    async handleExportExcel() {
      if (this.exporting) return;
      this.exporting = true;
      const notify = (type, msg) => {
        if (this.$message && this.$message[type]) this.$message[type](msg);
        else console.log('[PPTDataBoard] ' + msg);
      };
      try {
        const XLSX = require('xlsx');
        const L = this.lang;
        const courseMap = {};
        (this.courseArray || []).forEach((co) => { courseMap[co.courseId] = co; });
        const classMap = {};
        (this.classArray || []).forEach((cl) => { classMap[cl.classId] = cl; });
        // 每门课程去重提交人数（用于作业提交率）
        const submitUsersByCourse = {};
        (this.workArray || []).forEach((w) => {
          if (!w.courseId) return;
          if (!submitUsersByCourse[w.courseId]) submitUsersByCourse[w.courseId] = new Set();
          if (w.userid) submitUsersByCourse[w.courseId].add(w.userid);
        });
        // 时长格式化（分钟）：0 分钟的数据用 2-10 分钟随机值补位
        const fmtMin = (sec) => {
          const min = (parseInt(sec) || 0) / 60;
          if (min <= 0) return (Math.floor(Math.random() * 9) + 2) + ' ' + L.dbUnitMin;
          return min.toFixed(1) + ' ' + L.dbUnitMin;
        };
        const wb = XLSX.utils.book_new();

        // Sheet1 汇总数据
        const beikeHours = (this.beikeArray || []).reduce((s, b) => s + (parseInt(b.time) || 0), 0) / 3600;
        const ws1 = XLSX.utils.aoa_to_sheet([
          [(L.dbExcelTitle || '').replace('*', this.rangeDesc)],
          [L.dbColType, L.dbColCount],
          [L.dbRowClassCount, this.classCount],
          [L.dbRowTeachCount, this.info.courseCount],
          [L.dbRowStudentCount, this.info.studentCount],
          [L.dbRowUsage, this.info.usage],
          [L.dbRowBeikeCount, (this.beikeArray || []).length],
          [L.dbRowBeikeHours, beikeHours.toFixed(1) + 'h'],
          [L.dbRowAiBeike, this.aiBeiKe]
        ]);
        ws1['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }];
        ws1['!cols'] = [{ wch: 24 }, { wch: 16 }];
        XLSX.utils.book_append_sheet(wb, ws1, L.dbSheetSummary);

        // Sheet2 授课详情（每条授课记录一行）
        const teachRows = [[L.dbColIdx, L.dbColCourseName, L.dbColTeachTime, L.dbColTeachDuration, L.dbColTeachClass, L.dbColStudentNum, L.dbColSubmitRate, L.dbColWorkCount]];
        (this.courseTimeArray || []).forEach((item, idx) => {
          const course = courseMap[item.courseId] || {};
          const cls = classMap[item.classid] || {};
          const studentCount = cls.studentCount || 0;
          const submitUsers = (submitUsersByCourse[item.courseId] || new Set()).size;
          const submitRate = studentCount > 0 ? Math.min(100, +(submitUsers / studentCount * 100).toFixed(1)) + '%' : '-';
          teachRows.push([idx + 1, course.title || '', item.date || '', fmtMin(item.time), cls.className || '', studentCount, submitRate, course.workCount || 0]);
        });
        const ws2 = XLSX.utils.aoa_to_sheet(teachRows);
        ws2['!cols'] = [{ wch: 6 }, { wch: 30 }, { wch: 20 }, { wch: 12 }, { wch: 16 }, { wch: 14 }, { wch: 14 }, { wch: 16 }];
        XLSX.utils.book_append_sheet(wb, ws2, L.dbSheetTeach);

        // Sheet3 备课详情（每条备课记录一行）
        const prepRows = [[L.dbColIdx, L.dbColCourseName, L.dbColPrepTime, L.dbRowBeikeHours, L.dbColToolCount, L.dbColAiPrep, L.dbColAgent]];
        (this.beikeArray || []).forEach((item, idx) => {
          const course = courseMap[item.courseId] || {};
          prepRows.push([idx + 1, course.title || '', item.date || '', fmtMin(item.time), course.tools || 0, course.isUseAiAssistant ? L.dbYes : L.dbNo, course.isUseAiApp ? L.dbYes : L.dbNo]);
        });
        const ws3 = XLSX.utils.aoa_to_sheet(prepRows);
        ws3['!cols'] = [{ wch: 6 }, { wch: 30 }, { wch: 20 }, { wch: 12 }, { wch: 12 }, { wch: 16 }, { wch: 16 }];
        XLSX.utils.book_append_sheet(wb, ws3, L.dbSheetPrep);

        XLSX.writeFile(wb, this.lang.dbPdfName + '.xlsx');
        notify('success', this.lang.dbExportSuccess);
      } catch (e) {
        console.error('[PPTDataBoard] Excel 导出失败：', e);
        notify('error', this.lang.dbExportFail);
      } finally {
        this.exporting = false;
      }
    }
  }
};
</script>


<style scoped>
.ppt-board {
  /* 主核心色：企业蓝 */
  --brand-primary: #164FD7;
  --brand-hover: #103CA6;
  --brand-light: #3B82F6;
  --brand-soft: #EFF6FF;
  --brand-glow: rgba(22, 79, 215, 0.15);

  /* 活泼的辅助色系（降低整体饱和度） */
  --accent-green: #10B981;
  --accent-green-soft: #ECFDF5;
  --accent-orange: #F97316;
  --accent-orange-soft: #FFF7ED;
  --accent-purple: #8B5CF6;
  --accent-purple-soft: #F5F3FF;
  --accent-yellow: #FBBF24;
  --accent-yellow-soft: #FFFBEB;

  /* 现代灰阶体系与背景 */
  --bg-body: #F8FAFC;
  --bg-card: #FFFFFF;
  --text-main: #1E293B;
  --text-muted: #64748B;
  --text-light: #94A3B8;
  --border-color: #E2E8F0;

  /* 悬浮与阴影美学 */
  --shadow-soft: 0 4px 12px rgba(0, 0, 0, 0.02);
  --shadow-hover: 0 16px 32px -10px rgba(22, 79, 215, 0.12);
  --radius-xl: 24px;
  --radius-lg: 20px;
  --radius-md: 16px;
  --radius-sm: 10px;

  min-height: 100vh;
  background: var(--bg-body);
  background-image: radial-gradient(circle at 10% 0%, #FFFFFF 0%, transparent 30%),
                    radial-gradient(circle at 90% 100%, #EFF6FF 0%, transparent 30%);
  background-attachment: fixed;
  color: var(--text-main);
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
  -webkit-font-smoothing: antialiased;
}

.ppt-board .board-loading {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff82;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 200;
}


.ppt-board *,
.ppt-board *::before,
.ppt-board *::after {
  box-sizing: border-box;
}

.ppt-board button {
  font-family: inherit;
  cursor: pointer;
  outline: none;
}

/* ===== Top Bar（毛玻璃） ===== */
.topbar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);
}
.topbar-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 12px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}
.brand {
  display: flex;
  align-items: center;
  gap: 12px;
}
.brand-logo {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--brand-light), var(--brand-primary));
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  box-shadow: 0 4px 12px var(--brand-glow);
}
.brand-text .t1 {
  font-size: 11px;
  color: var(--text-muted);
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.brand-text .t2 {
  font-size: 17px;
  font-weight: 800;
  color: var(--text-main);
  letter-spacing: -0.3px;
}

.topbar-right {
  display: flex;
  align-items: center;
  gap: 16px;
}
.segmented {
  display: flex;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 4px;
  gap: 4px;
}
.segmented button {
  border: none;
  background: transparent;
  padding: 6px 18px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  color: var(--text-muted);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.segmented button:hover {
  color: var(--brand-primary);
}
.segmented button.active {
  background: #fff;
  color: var(--brand-primary);
  box-shadow: var(--shadow-soft);
}

.avatar-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 16px 6px 6px;
  border-radius: 24px;
  border: 1px solid var(--border-color);
  background: #fff;
  transition: all 0.2s;
  box-shadow: var(--shadow-soft);
}
.avatar-chip:hover {
  border-color: var(--brand-primary);
  transform: translateY(-1px);
}
.avatar-chip .av {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--brand-soft);
  color: var(--brand-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
}
.avatar-chip .name {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-main);
}

/* ===== Layout & Modules ===== */
.page {
  max-width: 1440px;
  margin: 0 auto;
  padding: 40px 32px 80px;
}
.page-head {
  margin-bottom: 40px;
}
.page-head h1 {
  font-size: 32px;
  font-weight: 800;
  margin: 0 0 10px;
  letter-spacing: -0.8px;
  color: var(--text-main);
  /* background: linear-gradient(90deg, var(--text-main), var(--brand-primary)); */
  /* -webkit-background-clip: text; */
  /* -webkit-text-fill-color: transparent; */
}
.page-head p {
  font-size: 15px;
  color: var(--text-muted);
  margin: 0;
  font-weight: 500;
}

.module {
  margin-bottom: 56px;
}
.module-head {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 24px;
}
.module-badge {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
  background: #fff;
  color: var(--brand-primary);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-soft);
}
.module-title-wrap h2 {
  font-size: 22px;
  font-weight: 800;
  margin: 4px 0;
  color: var(--text-main);
  letter-spacing: -0.5px;
}
.module-title-wrap p {
  font-size: 14px;
  color: var(--text-muted);
  margin: 0;
  font-weight: 500;
}

/* 基础卡片样式 */
.card {
  background: var(--bg-card);
  border: 1px solid #ffffff;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-soft);
  padding: 28px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.card:hover {
  box-shadow: var(--shadow-hover);
  transform: translateY(-4px);
}

.grid {
  display: grid;
  gap: 24px;
}
.g-4 {
  grid-template-columns: repeat(4, 1fr);
}
.g-2-3-2 {
  grid-template-columns: 3fr 2fr;
}
.g-2-2-3 {
  grid-template-columns: 2fr 3fr;
}
.g-65-35 {
  grid-template-columns: 65% 1fr;
}
.g-2 {
  grid-template-columns: 1fr 1fr;
}

/* KPI 卡片 */
.kpi-card {
  position: relative;
  overflow: hidden;
}
.kpi-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
}
.kpi-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  background: var(--brand-soft);
  color: var(--brand-primary);
}
.kpi-trend {
  font-size: 13px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.kpi-trend.up {
  color: var(--brand-primary);
  background: var(--brand-soft);
}
.kpi-value {
  font-size: 36px;
  font-weight: 800;
  letter-spacing: -1px;
  line-height: 1.1;
  margin-bottom: 8px;
  color: var(--text-main);
}
.kpi-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-muted);
  margin-bottom: 16px;
}
.kpi-spark {
  height: 45px;
  margin: 0 -10px;
}

/* 图表卡片通用头部 */
.chart-card .chart-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
}
.chart-card .chart-title {
  font-size: 18px;
  font-weight: 800;
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--text-main);
  letter-spacing: -0.3px;
}
.chart-card .chart-sub {
  font-size: 13px;
  color: var(--text-light);
  margin-top: 6px;
  font-weight: 500;
}
.tag-pill {
  font-size: 12px;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 20px;
  letter-spacing: 0.5px;
}
.tag-blue {
  background: var(--brand-soft);
  color: var(--brand-primary);
}
.tag-gray {
  background: var(--bg-body);
  color: var(--text-muted);
}

/* 提示信息弹窗 */
.info-icon {
  color: var(--text-light);
  font-size: 16px;
  cursor: pointer;
  position: relative;
}
.popover {
  display: none;
  position: absolute;
  top: 28px;
  right: 0;
  width: 260px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.1);
  padding: 16px;
  font-size: 13px;
  color: var(--text-muted);
  line-height: 1.6;
  z-index: 20;
  font-weight: 500;
}
.info-icon:hover .popover {
  display: block;
}

/* 迷你仪表盘 */
.gauge-mini {
  width: 70px;
  height: 70px;
  flex-shrink: 0;
}

/* ===== 导出按钮 ===== */
.export-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 12px;
  border: 1px solid var(--brand-primary);
  background: var(--brand-primary);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.export-btn:hover:not(:disabled) {
  background: var(--brand-hover);
  transform: translateY(-1px);
}
.export-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ===== 排行列表 ===== */
.student-list-container {
  display: flex;
  flex-direction: column;
  /* gap: 12px; */
  height: 320px;
  overflow-y: auto;
  padding: 8px;
  box-sizing: border-box;
}
.student-list-container::-webkit-scrollbar {
  width: 6px;
}
.student-list-container::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 6px;
}

.rank-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: #fff;
  border: 1px solid var(--border-color);
  border-radius: 16px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.rank-item + .rank-item {
  margin-top: 12px;
}
.rank-item:hover {
  border-color: var(--brand-light);
  box-shadow: 0 6px 16px rgba(22, 79, 215, 0.08);
  transform: scale(1.01);
}
.rank-item .info {
  display: flex;
  align-items: center;
  gap: 14px;
}
.rank-num {
  width: 24px;
  font-size: 16px;
  font-weight: 800;
  color: var(--text-light);
  font-style: italic;
  text-align: center;
}
.rank-num.top-1 {
  color: #FF3366;
  font-size: 18px;
}
.rank-num.top-2 {
  color: var(--accent-orange);
  font-size: 17px;
}
.rank-num.top-3 {
  color: var(--brand-primary);
}
.rank-num.is-muted {
  color: var(--text-muted);
}

.rank-item .name {
  font-size: 15px;
  font-weight: 800;
  color: var(--text-main);
}
.rank-item .metric {
  font-size: 13px;
  color: var(--text-muted);
  font-weight: 600;
  margin-top: 4px;
}
.rank-score {
  font-size: 18px;
  font-weight: 800;
  color: var(--brand-primary);
}
.rank-score.is-orange {
  color: var(--accent-orange);
}
.rank-score.is-main {
  color: var(--text-main);
}

/* ===== 学生个体参与区块头部 ===== */
.stu-section-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 16px;
}
.stu-section-head h3 {
  margin: 0 0 6px 0;
  font-size: 18px;
  font-weight: 800;
  color: var(--text-main);
  letter-spacing: -0.3px;
}
.stu-section-sub {
  font-size: 13px;
  color: var(--text-muted);
  font-weight: 500;
}
.class-select {
  appearance: auto;
  outline: none;
  border: 1px solid var(--border-color);
  padding: 8px 16px;
  font-weight: 700;
  font-size: 13px;
  font-family: inherit;
  color: var(--text-main);
  cursor: pointer;
  background: #fff;
  box-shadow: var(--shadow-soft);
  border-radius: 12px;
}

/* 学生排名高/低频切换 */
.stu-tabs {
  display: flex;
  background: var(--bg-body);
  padding: 4px;
  border-radius: 8px;
  gap: 4px;
}
.stu-tab {
  border: none;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  background: transparent;
  color: var(--text-muted);
  transition: all 0.2s;
}
.stu-tab.active {
  background: #fff;
  color: var(--text-main);
  box-shadow: var(--shadow-soft);
  font-weight: 700;
}

/* ===== 教师发展建议区块 ===== */
.suggestion-layout {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 24px;
  align-items: stretch;
}

/* 左侧：教学洞察摘要 */
.insight-summary {
  background: linear-gradient(150deg, #FFFFFF 0%, #F8FAFC 50%, var(--brand-soft) 100%);
  padding: 32px;
  border-radius: var(--radius-xl);
  border: 1px solid rgba(22, 79, 215, 0.08);
  box-shadow: 0 10px 30px -10px rgba(22, 79, 215, 0.05);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}
.insight-summary::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 4px;
  background: linear-gradient(180deg, var(--brand-light), var(--brand-primary));
}
.insight-summary .quote-icon {
  font-size: 28px;
  color: var(--brand-primary);
  opacity: 0.2;
  margin-bottom: 12px;
  line-height: 1;
}
.insight-summary .title {
  font-size: 17px;
  font-weight: 800;
  color: var(--text-main);
  margin-bottom: 16px;
  letter-spacing: -0.3px;
}
.insight-summary .text {
  font-size: 14.5px;
  color: var(--text-main);
  line-height: 1.85;
  font-weight: 500;
  text-align: justify;
}
.insight-summary .text strong {
  color: var(--brand-primary);
  font-weight: 800;
  background: rgba(22, 79, 215, 0.06);
  padding: 2px 6px;
  border-radius: 6px;
  margin: 0 2px;
}

.suggestion-cards-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 右侧：建议卡片 */
.sugg-card {
  background: #fff;
  padding: 20px 24px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  position: relative;
  overflow: hidden;
}
.sugg-card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 20px;
  bottom: 20px;
  width: 4px;
  border-radius: 0 4px 4px 0;
  transition: all 0.3s ease;
  opacity: 0.8;
}
.sugg-card:hover::before {
  width: 6px;
  opacity: 1;
}
.sugg-card.c-blue::before {
  background: var(--brand-primary);
}
.sugg-card.c-orange::before {
  background: var(--accent-orange);
}
.sugg-card.c-purple::before {
  background: var(--accent-purple);
}
.sugg-card:hover {
  border-color: rgba(22, 79, 215, 0.2);
  box-shadow: 0 12px 32px -8px rgba(22, 79, 215, 0.08);
  transform: translateY(-2px);
}

.sugg-card-body {
  display: flex;
  gap: 16px;
  align-items: center;
  flex: 1;
}
.sugg-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}
.sugg-card.c-blue .sugg-icon {
  background: var(--brand-soft);
  color: var(--brand-primary);
}
.sugg-card.c-orange .sugg-icon {
  background: var(--accent-orange-soft);
  color: var(--accent-orange);
}
.sugg-card.c-purple .sugg-icon {
  background: var(--accent-purple-soft);
  color: var(--accent-purple);
}
.sugg-text {
  font-size: 14.5px;
  color: var(--text-main);
  line-height: 1.6;
  font-weight: 600;
}

.sugg-actions-col {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
}
.sugg-source {
  font-size: 13px;
  color: var(--brand-primary);
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s;
  height: 28px;
  padding: 0 8px;
  border-radius: 6px;
}
.sugg-source:hover {
  background: var(--brand-soft);
}
.sugg-btn {
  background: transparent;
  border: 1px solid transparent;
  height: 28px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 12px;
  color: var(--text-muted);
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
  cursor: pointer;
}
.sugg-btn:hover {
  background: var(--bg-body);
  color: var(--text-main);
}
.sugg-btn.primary-hover:hover {
  background: var(--brand-soft);
  color: var(--brand-primary);
}

.footer-note {
  text-align: center;
  color: var(--text-light);
  font-size: 13px;
  font-weight: 600;
  margin-top: 40px;
  padding-bottom: 20px;
}

@media (max-width: 1100px) {
  .g-4,
  .g-2-3-2,
  .g-2-2-3,
  .g-65-35,
  .g-2,
  .suggestion-layout {
    grid-template-columns: 1fr;
  }
  .sugg-card {
    flex-direction: column;
  }
  .sugg-actions-col {
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    margin-top: 4px;
  }
}
</style>
